import api from "@/api";

export default {
  state: {
    policyStatuses: [],
  },
  getters: {
    policyStatuses: (state) => state.policyStatuses,
  },
  mutations: {
    setPolicyStatuses: (state, data) => {
      state.policyStatuses = data;
    },
  },
  actions: {
    getPolicyStatuses: async ({ commit }) => {
      try {
        const response = await api({ requiresAuth: true }).get(
          "/v1/policy-statuses"
        );
        const { data } = response.data;
        commit("setPolicyStatuses", data);
      } catch (err) {
        console.error(err);
      }
    },
  },
};
